import { Tabs } from "antd";
import React from "react";
import Rejected from "./Rejected";
import WaitingDecision from "./WaitingDecision";

const PartnerApproval = () => {
  return (
    <div>
      <div className="title-page">Referral Partners Approval</div>
      <div className="tab-container mt-25">
        <Tabs defaultActiveKey="1" destroyInactiveTabPane>
          <Tabs.TabPane tab="Waiting for decision" key="1">
            <WaitingDecision />
          </Tabs.TabPane>
          <Tabs.TabPane tab="Rejected" key="2">
            <Rejected />
          </Tabs.TabPane>
        </Tabs>
      </div>
    </div>
  );
};

export default PartnerApproval;
